import { LabelOffOutlined, SellOutlined } from '@mui/icons-material';
import { Box, Tab, styled } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { MetadataKeysTable } from '@/components/MetadataKeys/MetadataKeysTable';
import { ViewTabs } from '@/components/ViewTabs';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { usePageTitle } from '@/hooks/usePageTitle';
import { AssetsWithoutMetadataView } from './AssetsWithoutMetadataView';

export const METADATA_VIEW_PARAM = 'view';
export const ASSETS_WITHOUT_METADATA_VIEW = 'assets-without-metadata';
const FIELDS_VIEW = 'fields';

const PageRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  padding: '24px',
});

const TableBox = styled(Box)({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
});

export const MetadataPage = () => {
  usePageTitle('Metadata Fields');
  const { permissions } = useGetCurrentUser();
  const [searchParameters, setSearchParameters] = useSearchParams();

  const canManageFields = permissions.canManageMetadataFields;
  const requestedView = searchParameters.get(METADATA_VIEW_PARAM);
  const view =
    !canManageFields || requestedView === ASSETS_WITHOUT_METADATA_VIEW ? ASSETS_WITHOUT_METADATA_VIEW : FIELDS_VIEW;

  const selectView = (nextView: string) => {
    const updatedParameters = new URLSearchParams(searchParameters);
    if (nextView === FIELDS_VIEW) {
      updatedParameters.delete(METADATA_VIEW_PARAM);
    } else {
      updatedParameters.set(METADATA_VIEW_PARAM, nextView);
    }
    setSearchParameters(updatedParameters);
  };

  return (
    <PageRoot>
      <ViewTabs value={view} onChange={(_, nextView) => selectView(nextView)}>
        {canManageFields && (
          <Tab icon={<SellOutlined />} iconPosition='start' label='Metadata Fields' value={FIELDS_VIEW} />
        )}
        <Tab
          icon={<LabelOffOutlined />}
          iconPosition='start'
          label='Assets without metadata'
          value={ASSETS_WITHOUT_METADATA_VIEW}
        />
      </ViewTabs>
      {view === FIELDS_VIEW && (
        <TableBox>
          <MetadataKeysTable />
        </TableBox>
      )}
      {view === ASSETS_WITHOUT_METADATA_VIEW && <AssetsWithoutMetadataView />}
    </PageRoot>
  );
};
